import {gql} from "@apollo/client";

export const getMenus = gql`
  query getMenus {
    activeMenus {
      id
      name
      image
      details
      platesCount
      provider{fullName, avatar}
    }
  }
`

export const getMenuById = gql`
  query menuById($id: ID!) {
    menu( id: $id) {
      id
      name
      image
      details
      platesCount
      menuItems {
        id
        day
        active
        plate {
          id
          name
          image
          details
        }
        category {
          name, time
        }
        menu {id, name}
        history {
          ate, image
        }
      }
    }
  }
`

export const getMenuItem = gql`
  query menuItem($id: ID!) {
    menuItem( id: $id ) {
      id
      day
      menuId
      menu {id, name}
      category {id, name, time}
      plate {
        id, name, details, image
        plateIngredients{
          qty
          unit {
            name
          }
          qtyInfo
          ingredient {
            id
            name
          }
        }
      }
    }
  }
`
